<template>
  <!-- Snackbar for alert notifications -->
  <div>
    <v-snackbar
      v-for="(n, index) in notifications"
      :key="index"
      v-model="n.showing"
      bottom
      left
      :style="`bottom: ${(index) * 60}px`"
      v-bind="n.settings"
    >
      {{ n.message }}

      <template #action="{ attrs }">
        <v-btn
          v-if="n.hasButton"
          :color="n.buttonColor"
          text
          v-bind="attrs"
          icon
          @click="closeNotification(index)"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { ref, onMounted } from '@vue/composition-api';

import { EventBus } from '../../utils/index';

export default {
  setup () {
    const notifications = ref([]);

    const settings = {
      success: {
        hasButton: false,
        settings: {
          timeout: 4000,
          color: 'success'
        }
      },
      info: {
        hasButton: false,
        settings: {
          timeout: 4000,
          color: 'info'
        }
      },
      warning: {
        hasButton: false,
        settings: {
          timeout: 4000,
          color: 'warning'
        }
      },
      danger: {
        showing: true,
        hasButton: true,
        buttonColor: 'white',
        settings: {
          color: 'error',
          timeout: -1
        }
      }
    };

    const addNotification = notificationsReceived => {
      const notificationsToShow = [];
      notificationsReceived.map(notification => {
        const n = { ...settings[notification.type] };
        n.showing = true;
        n.message = notification.message;
        n.settings.timeout = notification.timeout ? notification.timeout : n.settings.timeout;
        notificationsToShow.push(n);
      });
      notifications.value = notificationsToShow;
    };

    const closeNotification = index => {
      notifications.value.splice(index, 1);
    };

    onMounted(() => {
      EventBus.$on('show-notifications', addNotification);
    });

    return { notifications, settings, addNotification, closeNotification };
  }
};

</script>
